var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"font-weight-bold px-12 app-button",class:[_vm.textColor, { isFaded: _vm.faded }],attrs:{"rounded":"","x-large":_vm.xLarge,"disabled":_vm.disabled,"outlined":_vm.outlined,"color":_vm.color,"min-height":_vm.minHeight,"min-width":_vm.minWidth},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }